import { hideModal } from 'helpers/dom'

function CartCheckout({ type, className, disabled = false }) {
  const isMiniCart = type === 'mini-cart'
  const cartURL = GM_STATE.routes.cart_url
  const closeModal = () => {
    hideModal('MiniCart')
  }

  return (
    <div className={className}>
      {isMiniCart && (
        <>
          <div className="flex gap-3 w-full">
            <a
              href={cartURL}
              className={`button-outlined js-close-modal-dialog w-1/2 flex-1 px-4 text-xs leading-6 md:text-sm ${disabled ? 'button-disabled' : ''}`}
            >
              {isMiniCart ? translate.cart.cart : translate.cart.go_to_cart}
            </a>
            <button type="submit" name="checkout" className={`button-primary ${isMiniCart ? 'w-1/2' : 'w-full'} flex-1 ${disabled ? 'button-disabled' : ''}`}>
              {isMiniCart ? translate.cart.checkout : translate.cart.go_to_checkout}
            </button>
          </div>
        </>
      )}
      {!isMiniCart && (
        <button type="submit" title={isMiniCart ? translate.cart.checkout : translate.cart.go_to_checkout} name="checkout" className={`button-primary ${isMiniCart ? 'w-1/2' : 'w-full'} flex-1 ${disabled ? 'button-disabled' : ''}`}>
          {isMiniCart ? translate.cart.checkout : translate.cart.go_to_checkout}
        </button>
      )}
    </div>
  )
}

export default CartCheckout
